<template>
  <section class="content">
    <box >
      <div slot="body">
        <div class="row">
          <div class="col-md-12">
              <h4>Descrição</h4>
              <input v-model="problema.descricao" type="text" class="form-control">
              <label v-if="descricao===''">*Campo Obrigatório</label>
          </div>
        </div>
        <div class="row" v-for="(linha, index) in problema.solucao">
            <div class="col-md-6">
                <h4>Solução {{index + 1}}</h4>
                <textarea v-model="linha.descricao" class="form-control" />
            </div>
            <div class="col-md-3 adicionaPreco" v-if="index === 0">
                <a @click="adicionarSolucao">Adicionar Solução</a>
            </div>
            <div class="col-md-3 adicionaPreco" v-else>
                <a @click="removerSolucao(index)"><i class="fa fa-times" aria-hidden="true"></i></a>
            </div>
        </div>
      <br><br>
      <router-link class="pageLink" to="/problemas">
              <button class="btn btn-danger" >Cancelar</button>
      </router-link>
      <button class="btn btn-success" @click="submit" v-show="habilitaGravar" >
        <i class="fa fa-check">  Gravar</i>
      </button>
      <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
      </div>
    </box>
  </section>
</template>

<script>
import resource from './resource';
import Box from '../Box'

export default {
  components: {
    'box': Box,
  },
  data: () => ({
    alteracao: false,
    idEditar: 0,
    problema: {
      descricao: '',
      solucao: [
          {
              descricao: ''
          }
      ],
    },
    gravando: false
  }),
  created() {
    if(this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true
      this.idEditar = this.$route.params.id
      this.getProblema(this.idEditar)
    }
  },
  computed: {
    nome: function () {
      if(this.alteracao) return 'alteracao Funcionário'
      else return 'Novo Funcionário'
    },
    habilitaGravar: function() {
      return this.problema.descricao && this.problema.solucao.length > 0   
    }
  },
  methods: {
    getProblema() {
        resource.getProblema(this.idEditar).then((res) => {
            console.log('res => ', res.data)
            this.problema = res.data
        })
    },
    adicionarSolucao() {
        this.problema.solucao.push({
            descricao: ''
        })
    },
    removerSolucao(i) {
        this.problema.solucao.splice(i, 1)
    },
    async submit() {
        this.problema.empresa = localStorage.getItem('FB_ID');

      if(this.alteracao) {
        resource.atualizaProblema(this.problema, this.idEditar).then((res) => {
          this.alteracao = false;
          this.$router.go(-1)
        }).catch(responseError => {
        });
      } else {
        resource.gravaProblema(this.problema).then((res) => {
          this.alteracao = false;
          this.$router.go(-1)
        }).catch(responseError => {
        })
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// novoProblema.vue?44bd90d6